import { emitUIEvent } from '@montugroup/data-collection';
import type { SelectChangeEvent } from '@mui/material/Select';
import MuiSelect from '@mui/material/Select';
import type { ReactNode } from 'react';
import type { SelectProps } from './Select.types';

export const Select = <T = unknown,>(props: SelectProps<T>) => {
  const { id, onChange, trackingContextId, ...rest } = props;

  const handleChange = (event: SelectChangeEvent<T>, child: ReactNode) => {
    if (id) {
      emitUIEvent(
        {
          component_name: 'Select',
          event_name: 'onChange',
          id,
          value: String(event.target.value ?? ''),
          context_id: trackingContextId,
        },
        [],
      );
    }

    onChange?.(event, child);
  };

  return <MuiSelect<T> id={id} onChange={handleChange} {...rest} />;
};
